import { render, staticRenderFns } from "./SoundTest.vue?vue&type=template&id=2a7ace70&scoped=true&"
import script from "./SoundTest.vue?vue&type=script&lang=js&"
export * from "./SoundTest.vue?vue&type=script&lang=js&"
import style0 from "./SoundTest.vue?vue&type=style&index=0&id=2a7ace70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ace70",
  null
  
)

export default component.exports